import React from 'react';
import {StyleProp, View, ViewStyle} from 'react-native';
import Label from '../../Label';
const primaryTitle = 'SOUSCRIPTION ASSURANCE VOYAGE';
const fourthTitle =
  '(La souscription est uniquement disponible pour les résidents à Madagascar)';

interface HeaderProp {
  style?: StyleProp<ViewStyle>;
}
export const Header = ({style = {}}: HeaderProp) => {
  return (
    <View style={style}>
      <Label title={primaryTitle} type="mainTitle" />
      <Label type="fourthTitle" title={fourthTitle} />
    </View>
  );
};
